import axios from "axios";

const isDev = true;

const axiosInstance = axios.create({
  baseURL: isDev
    ? "http://localhost/realmart_api/public"
    : "https://realmart.jemins.in/api/public",
  timeout: 100000,
  headers: { "Content-Type": "application/json" },
});

//Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json"; 
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      console.warn("Token expired. Redirecting to login...");
      localStorage.removeItem("token");

      // Avoid redirect loop
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
